import {
  HoldOpenOwnersPolicyNames,
  LendersPolicyNames,
  LongFormLendersPolicyNames,
  OwnersPolicyNames,
  ShortFormLendersPolicyNames,
} from 'types/order/documents/IDocumentCategoryType';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from 'types/rest/IFetchStatus';
import { eCDV3ItemTypes } from '../../../ui-toolkit/enums/eCDV3ItemTypes';
import { getStandardDocumentsByOrderId } from './DocumentsAPI';
import { IStandardDocument } from '../../../types/order/documents/shared/interfaces';
import { policyDocumentCategories } from '../../../types/policy/policyDocumentCategories';
import { policyFeeTypes } from '../../../types/policy/policyFeeTypes';
import { AppThunk } from '../../types';
import { addFetchError, setFeesCount, setFetchStatus, setPolicyDocuments } from './finalizePoliciesSlice';
import { getCDItemsByOwnerId } from '../../../ui-toolkit/cdItems/service/ServiceMethods';

export const weightLookup = {
  [OwnersPolicyNames.currentName]: 1,
  [OwnersPolicyNames.legacyName]: 1,
  [HoldOpenOwnersPolicyNames.currentName]: 1,
  [HoldOpenOwnersPolicyNames.legacyName]: 1,
  [LongFormLendersPolicyNames.currentName]: 2,
  [LongFormLendersPolicyNames.legacyName]: 2,
  [LendersPolicyNames.legacyName]: 2,
  [LendersPolicyNames.currentName]: 2,
  [ShortFormLendersPolicyNames.legacyName]: 3,
  [ShortFormLendersPolicyNames.currentName]: 3,
};
export const computeSortWeight = (document: IStandardDocument) => {
  const { category } = document;
  return category in weightLookup ? weightLookup[category] : 4;
};

export const getFinalizePoliciesDataAsync =
  (orderId: string): AppThunk =>
  async (dispatch) => {
    dispatch(setFetchStatus(createFetchInProgress()));
    const [cdItems, standardDocuments] = await Promise.all([
      getCDItemsByOwnerId(orderId),
      getStandardDocumentsByOrderId(orderId),
    ]);
    if (cdItems instanceof Error) {
      dispatch(addFetchError(standardDocuments));
    } else {
      dispatch(
        setFeesCount(
          cdItems.filter(
            (cdItem) => cdItem.type === eCDV3ItemTypes.title_fee && policyFeeTypes.includes(cdItem.sub_type as any)
          ).length
        )
      );
    }
    if (standardDocuments instanceof Error) {
      dispatch(addFetchError(standardDocuments));
    } else {
      dispatch(
        setPolicyDocuments(
          standardDocuments
            .filter((document) => policyDocumentCategories.includes(document.category as any))
            .sort((a, b) => computeSortWeight(a) - computeSortWeight(b))
        )
      );
    }
    if (cdItems instanceof Error || standardDocuments instanceof Error) {
      dispatch(setFetchStatus(createFetchedWithError()));
    } else {
      dispatch(setFetchStatus(createFetchedSuccess()));
    }
  };
